<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hhmNGr/tc-custom/FC-9781528957663.jpg?1684514748242?1705766068903" alt="This image is the cover for the book Midnight in Westminster Abbey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midnight in Westminster Abbey
      </h1>
      <p class="bookDescription body article font2">
        <p>The English kings who rise from their graves in Westminster Abbey on All Souls' Eve are in a terrible fix. They want visiting New Yorker Charlie Chancer to use his special IT skills to steal abbey funds and send them off to queens who have already come to life and escaped the abbey. Handsome commodities trader Charlie is also in a bind. He has whisked his young son, Georgie, away to London (amid a bitter custody battle with his ex-wife) to join his teenage daughter, Ginny, who is on a student exchange. Tudor queens show Georgie architectural wonders of the abbey. Plantagenet kings give Ginny picturesque tutorials on their colourful but devastating battles. But what are the kings to do with these visitors who have seen their dazzling coronation ceremony and their daring TV games? Kill them or free them when they may tell what they have seen?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Dennis Cashman
      </h2>
      
      <p class="authorDescription body article">Sean Dennis Cashman worked as a historian for New York University Press, an editor for the Ford Foundation and a music and theatre journalist for the New Haven Register. He taught at the University of Manchester, New York University and Adelphi University on Long Island where he was dean of arts and sciences. His America in the Gilded Age is a classic.	In this novel, he draws from his varied life to create a vivid tapestry mixing history, fantasy and satire. Kings buried in Westminster Abbey rise on All Souls' Eve. They entertain a New York family for a scary price.	OTHER BOOKS BY SDC INCLUDE:	America in the Gilded Age	America in the Age of the Titans: The Progressive Era and World War I	America Ascendant: From Theodore Roosevelt to FDR in the Century of American Power, 1901-1945	War in Pieces 1: Ivan the Terrible from Tulsa	War in Pieces 2: The Holly Wood Years of Ivan the Terrible	Luke Reader, blind detective</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eadbeb58